export const multiplyClassName = (arr: String[]) => arr.join(' ');
